<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <!-- <el-input size="medium" v-model="searchForm.key_words" placeholder="请输入搜索内容"  @keyup.enter.native="getTableList"></el-input> -->
      <el-select
        size="medium"
        v-model="searchForm.yearMonth"
        placeholder="请选择月份"
        @change="getTableList"
        clearable 
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a v-if="searchForm.yearMonth" :href="url+'/product/order/detail/export?orderId='+searchForm.orderId + '&&yearMonth='+searchForm.yearMonth" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
      <el-table-column
        width="120"
        prop="incomeDate"
        label="产出时间">
      </el-table-column>
      <el-table-column
        prop="totalCoin"
        label="当日产出(FIL)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.totalCoin,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="immediateRelease"
        label="当日产出立即释放(25%)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.immediateRelease,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="lineRelease"
        label="当日新增待释放(75%)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.lineRelease,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="todayImmediateRelease"
        label="今日产出立即释放">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.todayImmediateRelease,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="todayLineRelease"
        label="线性已释放(FIL)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.totalLineRelease,4)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="todayTotalRelease"
        label="总已释放(FIL)">
        <template slot-scope="scope">
          <span>{{$selfFunc.toNonExponential(scope.row.unfreezeNum,4)}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        orderId: '',
        yearMonth: null,
      },
      tableData: [],
      options: [],
      url: window.g.host
    };
  },
  created() {
    if (this.$route.query.orderId) {
      this.searchForm.orderId=this.$route.query.orderId
      this.getYearMonth();
    }
    // this.getTableList()
  },
  methods: {
    async getYearMonth() {
      let res = await this.$http.orderTimeline({orderId:this.searchForm.orderId});
      if (res) {
        // this.tableData=res.data.list
        console.log(res.data)
        if (res.data.length>0) {
          res.data.map((x)=>{
            this.options.push({
              value: x,
              label: x
            })

          })
          this.searchForm.yearMonth = res.data[0]
          this.getTableList()
        }
        // this.totalNum=Number(res.data.totalSize)
      }
    },
    async getTableList(){
       let res = await this.$http.orderCollectDetail({...this.searchForm});
        if (res) {
          this.tableData=res.data
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
